export default function PhilosophySection() {
  const highlights = [
    {
      icon: 'ri-group-line',
      title: 'Método prático para todas as idades',
      description: 'Do infantil ao adulto, cada aluno recebe atenção personalizada respeitando seu ritmo e objetivos.',
    },
    {
      icon: 'ri-user-voice-line',
      title: 'Profissionais Capacitados',
      description: 'Aprenda em um ambiente dinâmico e acolhedor, guiado por profissionais altamente dedicados ao seu desenvolvimento.',
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Ambiente focado no desenvolvimento do Reino',
      description: 'Um espaço onde a música é expressão de adoração e cada nota é tocada com propósito espiritual.',
    },
  ];

  return (
    <section id="filosofia" className="relative w-full bg-white py-24 md:py-32">
      <div className="w-full px-6 md:px-12 lg:px-16">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-16 lg:gap-20">
          <div className="w-full lg:w-1/2">
            <div className="flex flex-col items-center gap-5">
              <div className="relative w-full max-w-[420px] mx-auto lg:mx-0 aspect-[4/5] rounded-2xl overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/e52027607460cffc32b49812e98784ba/5f43e94816551e174102e08b6523106c.png"
                  alt="Thiago Lima - Fundador da TL Artes & Música"
                  title="Thiago Lima - Fundador da TL Artes & Música"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="text-center lg:text-left w-full max-w-[420px] mx-auto lg:mx-0">
                <span className="font-sans text-sm font-semibold text-night-blue">Thiago Lima</span>
                <span className="font-sans text-[13px] text-gray-400 font-light ml-2">Fundador &amp; Diretor</span>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex flex-col gap-8">
            <div className="inline-flex self-start">
              <span className="font-sans text-[11px] font-semibold tracking-[0.2em] uppercase text-vibrant-blue bg-light-blue/10 px-4 py-2 rounded-full">
                SOBRE NÓS
              </span>
            </div>

            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-night-blue leading-[1.15] tracking-tight max-w-[500px]">
              Muito mais que<br />notas e acordes.
            </h2>

            <div className="flex flex-col gap-5 max-w-[520px]">
              <p className="font-sans text-[15px] md:text-base text-gray-500 leading-[1.8]">
                A música é o encontro entre a técnica e a alma. Fundada por Thiago Lima, a <strong className="font-semibold text-night-blue">TL Artes &amp; Música</strong> nasceu para refinar essa conexão. Transformamos o aprendizado em um ato de disciplina, propósito e adoração, acolhendo desde os primeiros passos até o aperfeiçoamento técnico de excelência.
              </p>
            </div>

            <div className="flex flex-col gap-5 pt-2">
              {highlights.map((item, i) => (
                <div key={i} className="flex items-start gap-4 group">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-light-blue/10 group-hover:bg-light-blue/20 transition-colors">
                    <i className={`${item.icon} text-lg text-light-blue`}></i>
                  </div>
                  <div className="flex flex-col gap-0.5">
                    <span className="font-sans text-sm font-semibold text-night-blue leading-snug">{item.title}</span>
                    <span className="font-sans text-[13px] text-gray-400 leading-relaxed">{item.description}</span>
                  </div>
                </div>
              ))}
            </div>

            <a
              href="#cursos"
              className="group inline-flex items-center gap-2 self-start mt-2 font-sans text-sm font-semibold text-vibrant-blue hover:text-vibrant-blue/80 transition-colors whitespace-nowrap cursor-pointer"
            >
              Ver todos os cursos
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}